module.exports = __webpack_public_path__ + "static/img/2d4c49ec7677b6a97be63e620221b7ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon3.jpg
// module id = DRsu
// module chunks = 1